import type { Query, QueryClient } from "@tanstack/react-query";

import { PORTAL_HOME_SECTION_LIMIT } from "../../../config/portalAluno/constants";
import type { HomeContentData } from "../../../@types/portalAluno";
import { preloadImageSources } from "../images/imageCache";
import {
  getHomeContents,
  portalHomeQueryKey,
} from "./homeService";

const isCurrentUserHomeQuery = (query: Query, idUsuario?: number) => {
  const [scope, resource, queryUserId] = query.queryKey;
  return (
    scope === "portal-aluno" &&
    resource === "home" &&
    queryUserId === idUsuario
  );
};

export const invalidatePortalQueriesExceptHome = (
  queryClient: QueryClient,
  idUsuario?: number
) =>
  queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === "portal-aluno" &&
      !isCurrentUserHomeQuery(query, idUsuario),
  });

const getVisibleHomeImageSources = (home: HomeContentData) =>
  Object.values(home.sections).flatMap((cards) =>
    cards
      .slice(0, PORTAL_HOME_SECTION_LIMIT)
      .map((card) => card.imageUrl)
  );

/**
 * Atualiza a Home ainda na tela de detalhes e aquece as capas que estarão
 * visíveis no retorno. Essa rotina deve ser chamada apenas após uma conclusão.
 */
export const refreshHomeAfterContentCompletion = async (
  queryClient: QueryClient,
  idUsuario?: number
) => {
  if (!idUsuario) return undefined;

  const queryKey = portalHomeQueryKey(idUsuario);
  await queryClient.invalidateQueries({
    queryKey,
    exact: true,
    refetchType: "none",
  });
  const home = await queryClient.fetchQuery({
    queryKey,
    queryFn: getHomeContents,
    staleTime: 0,
  });

  await preloadImageSources(getVisibleHomeImageSources(home));
  return home;
};
